import { generateApiClient } from '@guiker/rest-client'

import { AdminApi, AuthApi, JwtApi } from '../api-definition'
import { config } from '../config'

export const AuthApiClient = generateApiClient(config.apiName, AuthApi.routes)
export const AdminApiClient = generateApiClient(config.apiName, AdminApi.routes)
export const JwtApiClient = generateApiClient(config.apiName, JwtApi.routes)
